import styled, { css } from 'styled-components'

const StyledWrapper = styled.div<{
  type?: 'card' | 'modal'
}>`
  .reply-btn {
    font-size: 12px;
    padding: 0px;
    background: none;
    border: none;
  }
  .comment-view {
    .user-profile {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      .lt {
        display: flex;
        margin-right: 4px;
        gap: 12px;
        overflow: hidden;
        .content {
          overflow: hidden;
          .top {
            gap: 4px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .user-name {
              display: block;
              font-size: 16px;
              font-weight: bold;
              padding-bottom: 2px;

              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .news-author {
              border: 1px solid #01a0ff;
              border-radius: 3px;
              color: #01a0ff;
              font-size: 10px;
              padding: 3px 5px;
              font-weight: 700;
              flex-shrink: 0;
            }
          }
          .user-info {
            font-size: 12px;
            color: #9f9f9f;
            display: flex;
            gap: 8px;
          }
        }
      }
    }
    .description {
      margin-left: 52px;
      background-color: #fafafa;
      padding: 12px 15px;
      border-radius: 5px;
      font-size: 14px;
      margin-bottom: 8px;

      .desc-content {
        margin-bottom: 4px;
        line-height: 22px;
        max-height: 66px;
        overflow: hidden;
        overflow-wrap: anywhere;
        &[data-expend='true'] {
          max-height: fit-content;
        }
      }
      .desc-more-btn {
        color: #777777;
      }
    }
  }
  .comment-edit {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    .rt {
      position: relative;
      width: 100%;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
      .edit-input {
        width: 100%;
        height: 40px;
      }
      .input-wrapper {
        position: relative;
        width: 100%;
        margin-left: 12px;
        padding: 10px;
        width: 100%;
        min-height: 36px;
        font-size: 12px;
        line-height: 16px;
        .comment-input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          textarea {
            height: 100%;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
      .btn-box {
        display: flex;
        gap: 4px;
      }
    }
  }

  .comment-delete {
    padding-bottom: 16px;
  }

  .comment-mute {
    padding-top: 4px;
    padding-bottom: 16px;
  }

  .tool-box {
    margin-left: 52px;
    font-size: 12px;
    color: #555;
    display: flex;
    gap: 8px;
    padding-bottom: 16px;
  }

  .comment-form {
    padding-left: 52px;
  }
  ${({ type }) =>
    type === 'modal' &&
    css`
      .user-profile {
        .lt {
          gap: 8px;
          .content {
            .user-name {
              font-size: 14px;
              padding-bottom: 0;
            }
          }
        }
      }
      .description {
        margin-left: 44px;
      }
      .tool-box {
        margin-left: 44px;
      }
    `}
`

export default StyledWrapper
